import React, { useState, useEffect } from 'react';

import axios from 'axios';
import dayjs from "dayjs";
import ModalLoad from '../../../components/modal/ModalLoad.js';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage.js';
import Calendar from '../../../components/calendar/Calendar.js';

function SubAdminMeter5m(props) {
    const [reportsite, setReportsite] = useState('P3-01');
    const [reportdate_dt, setReportdate_dt] = useState(dayjs(new Date()));

    const [data_list, setData_list] = useState({
        list: [],
        total_meter: 1
    });

    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })

    useEffect(() => {
        return () => {
            setData_list({
                list: [],
                total_meter: 1
            })
        }
    }, []);

    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });

    const onCalendaraChange = (date, dateString) => {
        setReportdate_dt(date)
    };
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(confirmcode) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    async function api_query_meter5m() {
        setmodal_load({ enable: true, message: "Loading meter calculation from database." })
        await sleep(500)

        const formData = new FormData()
        formData.append('reportsite', reportsite)
        formData.append('reportdate', dayjs(new Date(reportdate_dt)).format("YYYY-MM-DD"))

        axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/historical/advanced/meter5m", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    if (response.data.data !== null && response.data.data !== undefined) {
                        setData_list(response.data.data)
                    }
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
            })
            .catch((err) => {
                setData_list({
                    list: [],
                    total_meter: 1
                })
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    const handleExportCSV = () => {
        //  const total_column = (data_list.total_meter * 4) + 1
        // 2. กำหนดหัวตาราง (เรียงตาม Key ที่ต้องการดึงข้อมูล)
        let headers = ["datetimestamp_export", "power_active_solar1", "meter_acc_solar1", "meter_acc_solar1_exp", "meter_connected_solar1"];
        if (data_list.total_meter > 1) {
            headers.push("power_active_solar2", "meter_acc_solar2", "meter_acc_solar2_exp", "meter_connected_solar2")
        }
        if (data_list.total_meter > 2) {
            headers.push("power_active_solar3", "meter_acc_solar3", "meter_acc_solar3_exp", "meter_connected_solar3")
        }

        // ตั้งชื่อหัวข้อตารางที่จะแสดงในไฟล์จริง (Optional: ถ้าอยากให้เป็นภาษาไทย)
        let headerDisplay = ["datetimestamp", "m1_active", "m1_acc_imp", "m1_acc_exp", "m1_connected"];
        if (data_list.total_meter > 1) {
            headerDisplay.push("m2_active", "m2_acc_imp", "m2_acc_exp", "m2_connected")
        }
        if (data_list.total_meter > 2) {
            headerDisplay.push("m3_active", "m3_acc_imp", "m3_acc_exp", "m3_connected")
        }

        // 3. เริ่มแปลงข้อมูล
        const csvRows = [];

        // ใส่หัวตารางบรรทัดแรก
        csvRows.push(headerDisplay.join(","));

        // วนลูปดึงข้อมูลตาม Key ที่ระบุใน headers
        for (const item of data_list.list) {
            const values = headers.map((key, index) => {
                let val = item[key] !== undefined ? item[key] : ""; // กันเหนียวกรณีไม่มี key นั้น
                if (key.includes("connected")) {
                    val = item[key] !== undefined ? item[key] === true ? "1" : "0" : ""; // กันเหนียวกรณีไม่มี key นั้น
                }

                // ใส่เครื่องหมายคำพูดครอบไว้ เพื่อป้องกันตารางเบี้ยวหากในข้อมูลมีเครื่องหมายจุลภาค ( , )
                return `${String(val).replace(/"/g, '""').replace(/,/g, '')}`;
            });
            csvRows.push(values.join(","));
        }

        // 4. ประกอบร่างเป็นตัวอักษรเดียวคั่นด้วยการขึ้นบรรทัดใหม่
        const csvContent = csvRows.join("\n");

        // 5. สั่งดาวน์โหลดด้วย Blob (ใส่ \uFEFF ป้องกันภาษาไทยต่างด้าวใน Excel)
        const blob = new Blob(["\uFEFF" + csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "CPF_5min_" + dayjs(new Date(reportdate_dt)).format("YYYY-MM-DD") + ".csv");
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="fas fa-th-large"></i> Meter Calculation 5 Minutes</h4>
                                    <p className="mb-0">tracking your solar meter from table 5 minutes.</p>
                                </div>
                            </div>
                            <hr className="new-section-xs mb-2" />
                            <div className="d-flex gap-1 flex-wrap mb-4 print-disable">
                                <div className="d-block">
                                    <label htmlFor="reportsite" className="form-label mb-0">Select Site</label>
                                    <select id="reportsite" name="reportsite" className="form-select font-sarabun" value={reportsite} onChange={(e) => {
                                        setReportsite(e.target.value)
                                    }} required>
                                        {
                                            props.permitdata !== null ?
                                                props.permitdata?.sitescope_arr?.map((data, index) => (
                                                    <option value={data.sitecode_txt} key={data.sitecode_txt}>{data.sitecode_txt} {data.sitename_th}</option>
                                                ))
                                                :
                                                null
                                        }
                                    </select>
                                </div>
                                <div className="d-block " style={{ width: "160px" }}>
                                    <label htmlFor="reporttype" className="form-label mb-0">Select Date</label>
                                    <Calendar
                                        allowClear={false}
                                        className={"form-control"}
                                        onChange={onCalendaraChange}
                                        picker={"date"}
                                        style={{
                                            fontFamily: "poppins",
                                            fontSize: "0.75rem",
                                            Color: "black",
                                            lineHeight: "1.5",
                                            cursor: "pointer",
                                        }}
                                        value={reportdate_dt}
                                    />
                                </div>
                                <div className="d-block align-self-end print-disable" style={{ paddingBottom: "3px" }}>
                                    <button className="btn btn-info btn-sm me-5" onClick={() => { api_query_meter5m() }}><i className="fas fa-search me-2"></i> Query</button>
                                    <button className="btn btn-success btn-sm me-5" onClick={() => { handleExportCSV() }}>Export CSV</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3 mb-1 mb-md-4">
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered text-nowrap" >
                                <thead>
                                    <tr className="admintable-header">
                                        <th rowSpan={2}>Timestamp</th>
                                        <th colSpan={5}>Solar #1</th>
                                        {data_list?.total_meter > 1 ? <th colSpan={5}>Solar #2</th> : null}
                                        {data_list?.total_meter > 2 ? <th colSpan={5}>Solar #3</th> : null}
                                    </tr>
                                    <tr className="admintable-header">
                                        <th>Active Power</th>
                                        <th>Import ACC.</th>
                                        <th>Import 5m.</th>
                                        <th>Export ACC.</th>
                                        <th>Export 5m.</th>
                                        {data_list?.total_meter > 1 ? <th>Active Power</th> : null}
                                        {data_list?.total_meter > 1 ? <th>Import ACC.</th> : null}
                                        {data_list?.total_meter > 1 ? <th>Import 5m.</th> : null}
                                        {data_list?.total_meter > 1 ? <th>Export ACC.</th> : null}
                                        {data_list?.total_meter > 1 ? <th>Export 5m.</th> : null}
                                        {data_list?.total_meter > 2 ? <th>Active Power</th> : null}
                                        {data_list?.total_meter > 2 ? <th>Import ACC.</th> : null}
                                        {data_list?.total_meter > 2 ? <th>Import 5m.</th> : null}
                                        {data_list?.total_meter > 2 ? <th>Export ACC.</th> : null}
                                        {data_list?.total_meter > 2 ? <th>Export 5m.</th> : null}
                                    </tr>
                                </thead>
                                <tbody >
                                    {
                                        data_list?.list?.map((data, index) => (
                                            <tr key={index}>
                                                <td className='fw-600'>{data.datetimestamp_export}</td>
                                                <td className={data.meter_connected_solar1 ? "fw-600" : "text-danger fw-600"} >{data.power_active_solar1}</td>
                                                <td className={data.meter_connected_solar1 ? "fw-600" : "text-danger fw-600"} >{data.meter_acc_solar1}</td>
                                                <td className={data.meter_connected_solar1 ? "fw-600" : "text-danger fw-600"} >{data.meter_5m_solar1}</td>
                                                <td className={data.meter_connected_solar1 ? "fw-600" : "text-danger fw-600"} >{data.meter_acc_solar1_exp}</td>
                                                <td className={data.meter_connected_solar1 ? "fw-600" : "text-danger fw-600"} >{data.meter_5m_solar1_exp}</td>
                                                {data_list?.total_meter > 1 ? <td className={data.meter_connected_solar2 ? "fw-600" : "text-danger fw-600"} >{data.power_active_solar2}</td> : null}
                                                {data_list?.total_meter > 1 ? <td className={data.meter_connected_solar2 ? "fw-600" : "text-danger fw-600"} >{data.meter_acc_solar2}</td> : null}
                                                {data_list?.total_meter > 1 ? <td className={data.meter_connected_solar2 ? "fw-600" : "text-danger fw-600"} >{data.meter_5m_solar2}</td> : null}
                                                {data_list?.total_meter > 1 ? <td className={data.meter_connected_solar2 ? "fw-600" : "text-danger fw-600"}>{data.meter_acc_solar2_exp}</td> : null}
                                                {data_list?.total_meter > 1 ? <td className={data.meter_connected_solar2 ? "fw-600" : "text-danger fw-600"} >{data.meter_5m_solar2_exp}</td> : null}
                                                {data_list?.total_meter > 2 ? <td className={data.meter_connected_solar3 ? "fw-600" : "text-danger fw-600"} >{data.power_active_solar3}</td> : null}
                                                {data_list?.total_meter > 2 ? <td className={data.meter_connected_solar3 ? "fw-600" : "text-danger fw-600"} >{data.meter_acc_solar3}</td> : null}
                                                {data_list?.total_meter > 2 ? <td className={data.meter_connected_solar3 ? "fw-600" : "text-danger fw-600"} >{data.meter_5m_solar3}</td> : null}
                                                {data_list?.total_meter > 2 ? <td className={data.meter_connected_solar3 ? "fw-600" : "text-danger fw-600"}  >{data.meter_acc_solar3_exp}</td> : null}
                                                {data_list?.total_meter > 2 ? <td className={data.meter_connected_solar3 ? "fw-600" : "text-danger fw-600"} >{data.meter_5m_solar3_exp}</td> : null}
                                            </tr>
                                        ))
                                    }

                                </tbody>
                            </table>

                        </div>
                    </div>

                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminMeter5m